export interface ResultEnvelopeLike<T> {
  code: number;
  message?: string;
  data: T;
}

export function isResultEnvelopeLike<T>(payload: unknown): payload is ResultEnvelopeLike<T> {
  return Boolean(
    payload &&
      typeof payload === 'object' &&
      'code' in payload &&
      'data' in payload
  );
}

export function unwrapApiPayload<T>(payload: T | ResultEnvelopeLike<T>): T {
  return isResultEnvelopeLike<T>(payload) ? payload.data : payload;
}
